var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVector = function SvgVector(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50003 15C8.42535 15 8.35066 15.0109 8.27941 15.034C7.87441 15.1656 7.44847 15.25 7.00004 15.25C6.5516 15.25 6.12567 15.1656 5.72035 15.034C5.6491 15.0109 5.57473 15 5.50004 15C3.56067 15 1.98974 16.5775 2.00005 18.5193C2.00443 19.34 2.67911 20 3.50005 20H10.5C11.321 20 11.9957 19.34 12 18.5193C12.0103 16.5775 10.4394 15 8.50003 15ZM7.00004 14C8.65691 14 10 12.6569 10 11C10 9.34311 8.65691 7.99999 7.00004 7.99999C5.34317 7.99999 4.00005 9.34311 4.00005 11C4.00005 12.6569 5.34317 14 7.00004 14ZM20.5 4H8.50003C7.67285 4 7.00004 4.69531 7.00004 5.54968V6.99999C7.73191 6.99999 8.40941 7.21187 9.00003 7.55624V5.99999H20V15H18V13H14V15H11.6175C12.2144 15.5215 12.6525 16.2103 12.8578 17H20.5C21.3272 17 22 16.3047 22 15.4503V5.54968C22 4.69531 21.3272 4 20.5 4Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVector, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Vector.77d381c5.svg";
export { ForwardRef as ReactComponent };